import { filterParams } from '@/common/utils/format'
import { get, pick } from 'lodash-es'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

const DEFAULT_STARTUP_CONST_VALUE = '' // 启动费金额 默认值为 空
const DEFAULT_WEEK = 1 // 启动费开始收取的时间 默认值为1
const DEFAULT_STARTUP_EXEC_WEEK_VALUE = sprintf(i18n.gettext('签约%d周后'), DEFAULT_WEEK) // 启动费开始收取的时间 默认值为1
const DEFAULT_STARTUP_COST_PROPORTION_VALUE = '10%' // 启动费扣费比例 默认值为 10%
const DEFAULT_STARTUP_COST_LIMIT_VALUE = 500 // 单次最大扣费金额  默认值 500

const PARAMS_KEYS_LIST = [
  'startupCost',
  'startupExecWeek',
  'startupCostProportion',
  'startupCostLimit'
]

export function revert (data = {}) {
  const contractData = get(data, 'contractGlobal')
  let revertted = {}
  if (contractData) {
    // 这里是从接口读取字段。并且处理字段
    revertted = pick(contractData, PARAMS_KEYS_LIST)
    revertted.startupCost = (revertted.startupCost < 0 ? DEFAULT_STARTUP_CONST_VALUE : revertted.startupCost) + ''
    revertted.startupExecWeek = revertted.startupExecWeek ? sprintf(i18n.gettext('签约%d周后'), revertted.startupExecWeek) : DEFAULT_STARTUP_EXEC_WEEK_VALUE
    revertted.startupCostProportion = revertted.startupCostProportion ? `${revertted.startupCostProportion / 100}%` : DEFAULT_STARTUP_COST_PROPORTION_VALUE
    revertted.startupCostLimit = revertted.startupCost < 0 ? DEFAULT_STARTUP_COST_LIMIT_VALUE : (revertted.startupCostLimit / 100)
    return revertted
  }
  // 这里是接口没有字段，设置为默认值
  revertted = {
    startupCost: DEFAULT_STARTUP_CONST_VALUE, // 启动费金额 默认值为 空
    startupExecWeek: DEFAULT_STARTUP_EXEC_WEEK_VALUE, // 启动费开始收取的时间 默认值为1
    startupCostProportion: DEFAULT_STARTUP_COST_PROPORTION_VALUE, // 启动费扣费比例 默认值为 10%
    startupCostLimit: DEFAULT_STARTUP_COST_LIMIT_VALUE // 单次最大扣费金额  默认值 500
  }
  return revertted
}

export function submitFormat (contractGlobal) {
    return {
      params: JSON.stringify({
        queryId: this.$route.params.id,
        source: 'contractor',
        contractGlobal
      })
    }
  }

export default {
  revert,
  submitFormat
}
